export function usePDFExport() {
  const exportPDF = (elementId, filename = 'export', techMode = false) => {
    const originalTitle = document.title
    document.title = filename
    document.body.setAttribute('data-printing', elementId)
    if (techMode) {
      document.body.setAttribute('data-printing-tech', 'true')
    }

    // SafeResponsiveContainer ensures SVG elements are always in the DOM with valid
    // dimensions regardless of the parent container's overflow/height state.
    // The @media print CSS reveals the charts panel on a new page — no JS DOM
    // manipulation needed.
    setTimeout(() => {
      window.print()
      setTimeout(() => {
        document.title = originalTitle
        document.body.removeAttribute('data-printing')
        document.body.removeAttribute('data-printing-tech')
      }, 500)
    }, 50)
  }

  return { exportPDF }
}
